var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57229 3.62973C5.32811 4.53981 8.35962 4.03914 10.6785 2.28298L11.4631 1.68878L12.2435 2.27984C14.5658 4.03853 17.6019 4.53949 20.3615 3.62713L20.452 9.69547C20.534 15.1949 16.8003 20.0148 11.4642 21.3155C6.24217 20.0099 2.57246 15.3163 2.57238 9.92607L2.57229 3.62973ZM11.4954 1.66427C11.4954 1.66429 11.4954 1.6643 11.4954 1.66432L11.4954 1.66427Z",
    stroke: "#0C5CEF",
    strokeWidth: 0.730751
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.192 12.067C13.0435 11.766 13.6536 10.954 13.6536 9.99946C13.6536 8.78871 12.672 7.80721 11.4613 7.80721C10.2505 7.80721 9.26904 8.78871 9.26904 9.99946C9.26904 10.954 9.87908 11.766 10.7305 12.067V14.384C10.7305 14.7876 11.0577 15.1148 11.4613 15.1148C11.8649 15.1148 12.192 14.7876 12.192 14.384V12.067Z",
    fill: "#0C5CEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModel);
export default __webpack_public_path__ + "static/media/customModel.b34bebe1c84ddc1cb9d1179aaf35af90.svg";
export { ForwardRef as ReactComponent };